import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Container,
} from 'reactstrap'
import FeedbackModal from 'components/modals/FeedbackModal'
import { logOut } from 'actions/sessionActions'
import LoggedInNav from './LoggedInNav'
import LoggedOutNav from './LoggedOutNav'
import { Link } from 'react-router-dom'
import logo from 'assets/img/logo_white.png'
import './navbar.css'

export class MainNavbar extends Component {
  state = {
    modal: false,
    isOpen: false,
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  toggleModal = e => {
    e.preventDefault()
    this.setState({
      modal: !this.state.modal,
    })
  }

  onLogOut = e => {
    e.preventDefault()
    this.props.logOut()
  }

  render() {
    return (
      <Navbar className="navbar" expand="md">
        <Container>
          <NavbarBrand to="/" tag={Link}>
            <img src={logo} alt="Sputnik" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            {this.props.loggedIn ? (
              <LoggedInNav
                location={this.props.location}
                toggleModal={this.toggleModal}
                onLogOut={this.onLogOut}
              />
            ) : (
              <LoggedOutNav
                onLogOut={this.onLogOut}
                location={this.props.location}
              />
            )}
            <FeedbackModal
              isOpen={this.state.modal}
              toggle={this.toggleModal}
            />
          </Collapse>
        </Container>
      </Navbar>
    )
  }
}

export default connect(null, { logOut })(MainNavbar)



// WEBPACK FOOTER //
// ./src/components/nav/Navbar.js